import React, { useContext } from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

const Support = ({ handleShow }) => {
  const theme = localStorage.getItem("theme");

  // language
  const translations = {
    hi: {
      contact: "नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।",
      money: "राशि डालें  ",
      next: "आगे बड़े ",
      addAmount: "राशि जोड़ी जानी है ",
      referPerson: "रेफ़रल | ",
    },
    en: {
      contact: "Contact Us At Below Platforms.",
      money: "Enter Amount",
      next: "Next",
      addAmount: "Amount to be added",
      referPerson: "Referral",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "black",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles1 = {
    color: theme === "light" ? "black" : "white",
  };

  return (
    <div>
      <div className="leftContainer mt-3 pt-5  mb_space pb-0 vh-100" style={styles}>
        <div className="support-portal-container">
          {/* Modern Gradient Banner */}
          <div className="support-hero-section">
            <div className="hero-text">
              <h2 className="fade-in-title">Help Center</h2>
              <p>Got a question? We're available 24/7 to assist you.</p>
            </div>
            <div className="hero-visual">
              <img
                src="./images/support.jpg"
                alt="Support"
                className="hero-avatar"
              />
            </div>
          </div>

          <div className="support-content-body">
            <div className="section-divider">
              <span style={{ ...styles1 }}>
                {translations[language].contact}
              </span>
            </div>

            {/* Contact Grid */}
            <div className="contact-grid-layout">
              {/* WhatsApp Card */}
              {JSON.parse(localStorage.getItem("sitSetting"))
                ?.whatsappSupport && (
                <a
                  className="contact-tile whatsapp-tile"
                  href={
                    JSON.parse(localStorage.getItem("sitSetting"))
                      ?.whatsappSupport
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="tile-icon-box">
                    <img src="/images/whatsapp.png" alt="WhatsApp" />
                  </div>
                  <div className="tile-details">
                    <h4>WhatsApp Chat</h4>
                    <p>Instant reply within minutes</p>
                  </div>
                  <div className="tile-arrow">→</div>
                </a>
              )}

              {/* Email Card */}
              <a
                className="contact-tile email-tile"
                href="mailto:support@example.com"
              >
                <div className="tile-icon-box">
                  <img src="./images/mail.png" alt="Email" />
                </div>
                <div className="tile-details">
                  <h4>Email Support</h4>
                  <p>Get professional assistance</p>
                </div>
                <div className="tile-arrow">→</div>
              </a>
            </div>

          
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
